module.exports = __webpack_public_path__ + "img/p2_l.ce99ca62.jpg";